// TODO:

// * Handle delivery message
// * Update estimated delivery
// * remove update button

import NumberStepper from './number-stepper.js';

export function cart() {

	const cartCount = document.querySelector('#js-cart-count');
	
	const lineItems = Array.from(document.querySelectorAll('.line-item'));

	const standardDelivery = parseInt(document.querySelector('#standard_delivery').value);
	const minThreshold = parseInt(document.querySelector('#min_threshold').value);
	const maxThreshold = parseInt(document.querySelector('#max_threshold').value);
	const cartDeliveryMessage = document.querySelector('.js-cart-delivery-msg');
	const freeDeliveryThreshold = parseInt(document.querySelector('#free_delivery_threshold').value);
	const freeDeliveryMessage = document.querySelector('#free_delivery_message').value;
	const nearlyDeliveryMessage = document.querySelector('#cart_nearly_free_msg').value;
	const deliveryPriceEl = document.querySelector('.js-cart-delivery-price');
	const subtotalEl = document.querySelectorAll('.js-sub-total');
	const freeDeliveryLabel = document.querySelector('#free_delivery_label').value;
	const moneyFormat = document.querySelector('#js-money-format').value
	const cartUpdateEl = document.querySelector('#cart-update-wrap');

	cartUpdateEl.classList.add('hidden');

	// Init Number Steppers
	const steppers = document.querySelectorAll('.js-number-stepper');

	if (steppers.length) {
		[].forEach.call(steppers, function(item, i) {
			new NumberStepper(steppers[i]);
		});
	}

	lineItems.forEach((li) => {

		let ns = li.querySelector('.js-number-stepper');
		let nsInput = ns.querySelector('input');
		let nsPlus = ns.querySelector('.js-number-stepper-plus');
		let nsMinus = ns.querySelector('.js-number-stepper-minus');
		let variant = li.querySelector('.js-line-item-variant-id').value;

		nsInput.addEventListener('change', (e) => {
			updateCart(variant, e.target.value);
			// Fire custom event for gift wrap app
			 document.dispatchEvent(new CustomEvent('wrapped:cart:verify'));
		})

		nsPlus.addEventListener('click', (e) => {
			updateCart(variant, nsInput.value);
			// Fire custom event for gift wrap app
			 document.dispatchEvent(new CustomEvent('wrapped:cart:verify'));
		})
		nsMinus.addEventListener('click', (e) => {
			updateCart(variant, nsInput.value);
			// Fire custom event for gift wrap app
			 document.dispatchEvent(new CustomEvent('wrapped:cart:verify'));
		})



	});

	function updateDeliveryPrice(cartTotal) {

		let subTotal = parseInt(cartTotal);
		let msgLabelEl = cartDeliveryMessage.querySelector('.icon span.bold')

		if (subTotal <= maxThreshold && subTotal >= minThreshold) {
			msgLabelEl.innerHTML = nearlyDeliveryMessage;
			let diff = document.querySelector('.js-free-delivery-diff');
			diff.innerHTML = Shopify.formatMoney(freeDeliveryThreshold - cartTotal, moneyFormat);
			cartDeliveryMessage.classList.remove('hidden');
			deliveryPriceEl.innerHTML = Shopify.formatMoney(standardDelivery, moneyFormat);
			return
		} 
		
		if (subTotal >= freeDeliveryThreshold) {
			msgLabelEl.innerHTML = freeDeliveryMessage;
			cartDeliveryMessage.classList.remove('hidden');
			deliveryPriceEl.innerHTML = freeDeliveryLabel;
			return
		}
		
		cartDeliveryMessage.classList.add('hidden');
		deliveryPriceEl.innerHTML = Shopify.formatMoney(standardDelivery, moneyFormat);

	}

	function updateSubtotal(cartTotal) {
		[].forEach.call(subtotalEl, (el) => {
			return el.innerHTML = Shopify.formatMoney(cartTotal, moneyFormat);
		})
	}
	
	function updateCart(variant, qty) {

		let data = {
			updates: {}
		};
		
		data.updates[variant] = qty;

		fetch('/cart/update.js', {
			method: 'POST',
			body: JSON.stringify(data),
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
			},
		}).then(function(response) {

			return response.json();

		}).then(function(json) {
			// Shopify error which is not returned as an error 😫
			if (json.status === 422) {
				console.error(json)
				
				return
			}

			// SUCCESS
			updateSubtotal(json.total_price);
			updateDeliveryPrice(json.total_price);
			updateCartCount(json.item_count);
			updateLineItem(variant, json.items)
		}).catch(function(err) {

			/* uh oh, we have a REAL error. */
			
			console.error('add to cart err', err)
			

		});
	
	}

	function updateCartCount(num) {
	
			cartCount.innerHTML = num

	}

	function updateLineItem(variant, itemsArr) {
		const lineItemPrice = document.querySelector(`#variant-price-${variant}`).querySelector('.js-price');
		const lineItemData = itemsArr.find((item) => variant == item.id);
		lineItemPrice.innerHTML = Shopify.formatMoney(lineItemData.final_line_price, moneyFormat);

	}
}